/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// @mui material components
import { useState } from 'react'

import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

import profilePicture from 'assets/images/account-icons/default-black.png'
import profilePictureWhite from 'assets/images/account-icons/default-white.png'
import MDAvatar from 'components/MDAvatar'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAuth } from 'context/auth'
import { useMaterialUIController } from 'context/materialUI'
import { toTitleCase } from 'utils/string'

function Header(): JSX.Element {
	const [controller] = useMaterialUIController()
	const { user } = useAuth()
	const { darkMode } = controller
	const [imageLoaded, setImageLoaded] = useState<boolean>(false)

	const handleImageLoad = () => {
		setImageLoaded(true)
	}

	return (
		<Card id="profile">
			<MDBox p={2}>
				<Grid container spacing={3} alignItems="center">
					<Grid item>
						<MDAvatar
							src={darkMode ? profilePictureWhite : profilePicture}
							alt="profile-image"
							size="xl"
							shadow="sm"
						/>
					</Grid>
					<Grid item>
						<MDBox height="100%" mt={0.5} lineHeight={1}>
							<MDTypography variant="h5" fontWeight="medium">
								{user.data.name ? user.data.name : 'User Name'}
							</MDTypography>
							<MDTypography variant="button" color="text" fontWeight="regular">
								{user.auth.email}
							</MDTypography>
							<MDTypography
								variant="button"
								color="text"
								fontWeight="medium"
								component="span"
								sx={{ mx: 1 }}
							>
								|
							</MDTypography>
							<MDTypography variant="button" color="text" fontWeight="regular">
								{toTitleCase(user.data.role) ?? ''}
							</MDTypography>
						</MDBox>
					</Grid>
					<Grid item xs={12} md={6} lg={3} sx={{ ml: 'auto' }}>
						<MDBox
							display="flex"
							justifyContent={{ md: 'flex-end' }}
							alignItems="center"
							lineHeight={1}
							gap={8}
						>
							<MDBox mr={5} alignItems="center" display={'flex'} flexDirection={'column'}>
								<MDBox
									component="img"
									src={user.data.organisation.logo}
									alt="Brand"
									width="4rem"
									onLoad={handleImageLoad}
									style={{
										opacity: imageLoaded ? 1 : 0,
										transition: 'opacity 0.5s ease-in-out',
									}}
								/>
								<MDTypography component="h6" variant="button" fontWeight="medium">
									{user.data.organisation.name}
								</MDTypography>
							</MDBox>
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</Card>
	)
}

export default Header
